import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { RealWorldSolutions } from "../legacy/real-world-solutions";
import { GridPatternBackground } from "../shared";

export const RealWorldSolutionsSection = () => {
  useSectionNavTheme({
    trigger: "#real-world-solutions",
    isDark: false,
  });

  return (
    <section
      className="real-world-solutions relative text-white py-10 bg-gradient-to-b from-haizea-green/30 via-haizea-blue/20"
      id="real-world-solutions"
    >
      <GridPatternBackground />
      <RealWorldSolutions largeTitle />
    </section>
  );
};
